(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityTemplateUsageGrid', drvEntityTemplateUsageGrid);

    drvEntityTemplateUsageGrid.$inject = [];
    drvEntityTemplateUsageGridCtrl.$inject = [];

    /**
     * Displays a list of 'Item Count for Entity Template' in a grid.
     *
     * # Scope Properties
     * {array} items - Array of 'Item Count for Entity Template', refer to ItemCountForEntityTemplateViewModel.cs
     * {string} mode - Is the grid for 'Usage' or 'Delete' viewing. These scenarios use different wording
     * {bool} showCheckbox - Is a selection checkbox shown for the items, this is only applicable to 'Delete' mode. Optional.
     */
    function drvEntityTemplateUsageGrid() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: drvEntityTemplateUsageGridCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                items: '=',
                mode: '<',
                showCheckbox: '<?'
            },
            templateUrl: 'app/EntityTemplate/entity-template-usage-grid.tmpl.html'
        };
        return directive;
    }

    function drvEntityTemplateUsageGridCtrl() {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.getEntityTemplateCountHtml = getEntityTemplateCountHtml;

        /**
         * Get the HTML to be used for displaying the item counts for an entity template
         *
         * @param {object} entityTemplateCount - Item count details for the entity template. Refer to ItemCountForEntityTemplateViewModel.cs
         *
         * @returns {string} - Returns details about the item count for an entity template in HTML format
         */
        function getEntityTemplateCountHtml(entityTemplateCount) {
            var sentencePrefix = '';
            if (drvCtrl.mode === 'Delete') {
                sentencePrefix = 'Will also delete ';
            } else if (drvCtrl.mode === 'Usage') {
                sentencePrefix = 'Used by ';
            }

            var html = '';

            if (entityTemplateCount.EntityTemplate.Standalone) {
                if (entityTemplateCount.EntityAccessPermission && entityTemplateCount.EntityCount > 0) {
                    html += sentencePrefix + '<a target="_blank" href="#entities/?entityTemplateId=' + entityTemplateCount.EntityTemplate.Id + '">' + entityTemplateCount.EntityCount + ' ' + entityTemplateCount.EntityTemplate.PluralName + '</a>';
                } else if (!entityTemplateCount.EntityAccessPermission) {
                    html += sentencePrefix + entityTemplateCount.EntityTemplate.PluralName + ' you cannot access';
                }

                if (entityTemplateCount.DocumentTemplateCount > 0) {
                    if (html === '') {
                        html += sentencePrefix;
                    } else {
                        html += ' and ';
                    }

                    html += '<a target="_blank" href="#documenttemplates/?entityTemplateId=' + entityTemplateCount.EntityTemplate.Id + '">' + entityTemplateCount.DocumentTemplateCount + ' Document Templates</a>';
                }
            }

            if (html !== '') {
                html += '<br/>';
            }

            return html;
        }
    }
})();